// Tribute: https://medium.com/dzangolab/vue-js-environment-variables-799fc080d736

const config = {
  apiBaseUrl: parse(process.env.VUE_APP_API_BASE_URL, ''),
  features: {
    useApi: parse(process.env.VUE_APP_USE_API, true)
  }
}

function parse (value, fallback) {
  if (typeof value === 'undefined') {
    return fallback
  }

  switch (typeof fallback) {
    case 'boolean' :
      return !!JSON.parse(value)
    case 'number' :
      return JSON.parse(value)
    default :
      return value
  }
}

function feature (name) {
  return config.features[name]
}

export default {
  install (Vue) {
    Vue.appConfig = config
    Vue.feature = feature
    Vue.prototype.$appConfig = config
    Vue.prototype.$feature = feature
  }
}
